export default "<div class=\"container my-4\">\n</div>"